// extracted by mini-css-extract-plugin
export default {"row":"TableBodyRow_row__qmC8M"};